import React from 'react'
import { injectMessages } from '@/logic/translation/utils'
import { BannerWithLink } from '../'
import type { IFaqAgroservicesBanner } from './interfaces'
import messages from './messages.json'

injectMessages(messages)

const FaqAgroservicesBanner: React.FC<IFaqAgroservicesBanner> = ({ className }) => {
  return (
    <BannerWithLink
      className={className}
      contentTextId="banner.faq.content"
      linkTextId="banner.faq.link"
      link="/agroservices/agroconsulting"
    />
  )
}

export default FaqAgroservicesBanner
